
import Vue from 'vue'
import Vuex from 'vuex'
import constants from '../plugins/constants'
import { getApiUrl } from '../plugins/serviceUrls'

Vue.use(Vuex)

const resolveClientId = (client) => (client && typeof client === 'object' ? client._id : client);

const resolveBoundClientId = (rootState) => {
  const rawClient =
    rootState?.client ||
    rootState?.auth?.boundClient ||
    rootState?.user?.client ||
    '';
  if (rawClient && typeof rawClient === 'object') {
    return rawClient._id || rawClient.id || '';
  }
  return rawClient || '';
};

const resolveClientDetails = (clientList, client) => {
  const clientId = resolveClientId(client);
  if (!clientId || !Array.isArray(clientList)) return {};
  return clientList.find(item => item && item._id === clientId) || {};
};

function transformLabels(input) {
  if (!input || typeof input !== 'object') return {};

  const output = {};
  for (const page in input) {
    if (!Array.isArray(input[page])) continue;

    output[page] = {};
    input[page].forEach(({
      label_id,
      value,
      default: defaultValue,
    }) => {
      if (!label_id) return;
      const normalizedKey = label_id.trim().replace(/\s+/g, '_').replace(/lebel/g, 'label');
      output[page][normalizedKey] = {
        value,
        default: defaultValue,
      };
    });
  }
  return output;
}

export default new Vuex.Store({
  state: {
    // 1 while the boot splash is up; App.vue unmounts the overlay at 0.
    loading: 1,
    navigation: true,
    headeraction: true,
    sbsuccess: false,
    sbsuccessmsg: "",
    sberror: false,
    sberrormsg: "",
    sbinfo: false,
    sbinfomsg: "",
    sbwarning: false,
    sbwarningmsg: "",
    sidebarFlag: false,
    noauth: false,
    login: false,
    mininavbar: true,
    user: {},
    permission: {},
    isadmin: false,
    subscriptions: {},
    clientlist: [],
    clientDetails: {},
    containerheight: '0',
    client: "",
    clientCode: "",
    refreshclient: false,
    menu: [],
    newmenu: [],
    custommenu: [],
    aiEnabled: false,
    permissionsEnabled: false,
    isFlowEnabled: false,
    isQueueManagementEnabled: false,
    queueList: [],
    flattened_gl_hierarchy: false,
    user_permissions_superadmin: false,
    chatbotEnabled: false,
    accrualsbotEnabled: false,
    accrualsBotFlagReady: false,
    pinCount: -1,
    loginTime: null,
    tasklistUserType: null, // 'manager' or 'preparer'
    menulist: {
    },
    downloadLoading: false,
    downloadHighlight: false,
    download: [],
    downloaderror: "",
    progressLoading:false,
    snackMultValue:[],
    sidedraweropen:false,
    projectName:"",
    LocationHeader:'',
    filteredLocations: [], // Store filtered locations for cycle
    labels:{},
    labelsInFlightClient: null,
    labelsClient: null,
    industries: [
      "Agriculture",
      "Construction",
      "Consumer Services",
      "Business Services",
      "Education",
      "Energy, Utilities & Waste",
      "Finance",
      "Healthcare Services",
      "Holding Companies & Conglomerates",
      "Hospitality",
      "Hospitals & Physicians Clinics",
      "Insurance",
      "Law Firms & Legal Services",
      "Manufacturing",
      "Media & Internet",
      "Minerals & Mining",
      "Organizations",
      "Real estate",
      "Software",
      "Telecommunications",
      "Transportation"
    ],
    sectors: {
      "Agriculture": ["Animals & Livestock", "Crops", "Forestry"],
      "Construction": ["Architecture, Engineering & Design", "Civil Engineering", "Construction", "Commercial & Residential Co"],
      "Consumer Services": ["Automotive Service & Collision Repair", "Barber Shops & Beauty Salons", "Car & Truck Rental", "Childcare", "Cleaning Services", "Funeral Homes & Funeral Related Services", "Landscape Services", "Photography Studio", "Repair Services", "Weight & Health Management"],
      "Business Services": ["Accounting Services", "Advertising & Marketing", "Call Centers & Business Centers", "Chambers of Commerce", "Commercial Printing", "Custom Software & IT Services", "Debt Collection", "Facilities Management & Commercial Cleaning", "Food Service", "HR & Staffing", "Information & Document Management", "Management Consulting", "Multimedia & Graphic Design", "Research & Development", "Security Products & Services", "Translation & Linguistic Services"],
      "Education": ["Colleges & Universities", "K-12 Schools", "Training"],
      "Energy, Utilities & Waste": ["Electricity", "Oil & Gas Exploration & Services", "Waste Treatment, Environmental Services & Recycling", "Water Treatment"],
      "Finance": ["Banking", "Credit Cards & Transaction Processing", "Investment Banking", "Lending & Brokerage", "Venture Capital & Private Equity"],
      "Government": ["Federal", "Local", "State", "Tribal Nations"],
      "Healthcare Services": ["Ambulance Services", "Blood & Organ Banks", "Elderly Care Services", "Medical Laboratories & Imaging Centers", "Mental Health & Rehabilitation Facilities", "Veterinary Services"],
      "Holding Companies & Conglomerates": [],
      "Hospitality": ["Amusement Parks", "Arcades & Attractions", "Cultural & Informational Centers", "Fitness & Dance Facilities", "Gambling & Gaming", "Libraries", "Lodging & Resorts", "Movie Theaters", "Museums & Art Galleries", "Performing Arts Theaters", "Restaurants", "Sports Teams & Leagues", "Travel Agencies & Services", "Zoos & National Parks"],
      "Hospitals & Physicians Clinics": ["Dental Offices", "Medical & Surgical Hospitals", "Medical Specialists", "Physicians Clinics"],
      "Insurance": [],
      "Law Firms & Legal Services": [],
      "Manufacturing": ["Aerospace & Defense", "Appliances", "Automotive Parts", "Boats & Submarines", "Building Materials", "Chemicals & Related Products", "Cleaning Products", "Computer Equipment & Peripherals", "Cosmetics, Beauty Supply & Personal Care Products", "Electronics", "Food & Beverage", "Furniture", "Glass & Clay", "Hand, Power & Lawn-care Tools", "Health & Nutrition Products", "Household Goods", "Industrial Machinery & Equipment", "Medical Devices & Equipment", "Motor Vehicles", "Pet Products", "Pharmaceuticals", "Photographic & Optical Equipment", "Plastic, Packaging & Containers", "Pulp & Paper", "Sporting Goods", "Telecommunication Equipment", "Test & Measurement Equipment", "Textiles & Apparel", "Tires & Rubber", "Toys & Games", "Watches & Jewelry", "Wire & Cable"],
      "Media & Internet": ["Broadcasting", "Data Collection & Internet Portals", "Music Production & Services", "Newspapers & News Services", "Publishing", "Social Networks", "Ticket Sales"],
      "Minerals & Mining": [],
      "Organizations": ["Membership Organizations", "Non-Profit & Charitable Organizations", "Religious Organizations"],
      "Real estate": [],
      "Retail": ["Apparel & Accessories Retail", "Auctions", "Automobile Dealers", "Automobile Parts Stores", "Consumer Electronics & Computers Retail", "Convenience Stores, Gas Stations & Liquor Stores", "Department Stores, Shopping Centers & Superstores", "Drug Stores & Pharmacies", "Flowers, Gifts & Specialty Stores", "Furniture", "Grocery Retail", "Home Improvement & Hardware Retail", "Jewelry & Watch Retail", "Office Products Retail & Distribution", "Other Rental Stores (Furniture, A/V, Construction & Industrial Equipment)", "Pet Products", "Record, Video & Book Stores", "Sporting & Recreational Equipment Retail", "Toys & Games", "Vitamins, Supplements & Health"],
      "Software": ["Business Intelligence (BI) Software", "Content & Collaboration Software", "Customer Relationship Management (CRM) Software", "Database & File Management Software", "Engineering Software", "Enterprise Resource Planning (ERP) Software", "Financial Software", "Healthcare Software", "Human Resources Software", "Legal Software", "Mobile App Development", "Multimedia, Games & Graphics Software", "Networking Software", "Security Software", "Storage & System Management Software", "Supply Chain Management (SCM) software"],
      "Telecommunications": ["Cable & Satellite", "Internet Service Providers", "Website Hosting & Internet-related Services", "Telephony & Wireless"],
      "Transportation": ["Airlines", "Airports & Air Services", "Freight & Logistics Services", "Marine Shipping & Transportation", "Rail, Bus & Taxi", "Trucking, Moving & Storage"]
    },
    size: ["0 - 50 million", "50 - 150 million", "$150 - 500 million", "500 to 1bn", "Greater than 1bn"],
    selectdata: {
      type: [
        { name: "Individual", value: "Individual" },
        { name: "Company", value: "Company" },
        { name: "Firm", value: "Firm" },
        { name: "Trust", value: "Trust" },
        { name: "Government", value: "Government" },
        { name: "Others", value: "Others" },
      ],
    },
    plans: [
      {
        value: "62a2e0118f760000ea00694a",
        name: "Information Workflow - Free",
      },
      {
        value: "62a2e01f8f760000ea00694b",
        name: "Information Workflow - Paid",
      },
      { value: "630723c2db500000a0003ea7", name: "Earnout" },
      { value: "62fba20ba107000006001136", name: "TDS - AR" },
    ],
    datatableHeaders: [
      {
        value: "indexno",
        text: "#",
        sortable: false,
        filterable: false,
      },
      {
        value: "name",
        text: "Name",
        lock: true,
        visible: false,
      },
      {
        value: "contactemail",
        text: "Email",
        lock: true,
        visible: false,
      },
      {
        value: "type",
        text: "Type",
        lock: true,
        visible: false,
      },
      {
        value: "contactno",
        text: "Contact No.",
        datatype: "string",
        visible: true,
      },
      {
        value: "address",
        text: "Address",
        visible: true,
      },
      {
        value: "aiEnabled",
        text: "Gen AI Status",
        visible: true,
        alignment: "text-center",
      },
      {
        value: "schedulerEnabled",
        text: "Notifications Status",
        lock: true,
        visible: true,
        alignment: "text-center",
      },
      {
        value: "userPermission",
        text: "User Permission",
        lock: true,
        visible: true,
        alignment: "text-center",
      },
      {
        value: "pinCount",
        text: "Shortcut",
        visible: true,
        alignment: "text-center",
      },
      {
        value: "chatbotEnabled",
        text: "Chatbot",
        visible: true,
        alignment: "text-center",
      },
      {
        value: "horizonViewEnabled",
        text: "Horizon View",
        visible: true,
        alignment: "text-center",
      },
      {
        value: "exportManagerEnabled",
        text: "Export Manager",
        visible: true,
        alignment: "text-center",
      },
      {
        value: "upsiEnabled",
        text: "UPSI Controls",
        visible: true,
        alignment: "text-center",
      },
      {
        value: "accrualsbotEnabled",
        text: "Accruals Bot",
        visible: true,
        alignment: "text-center",
      },
    ],
    erpEnabled: {},
    isComparitive1enabled: false,
    isComparitive2enabled: false,
    // Persisted datatable filters keyed by composite key (page + scope)
    tableFilters: {},
  },

  mutations: {
    setTasklistUserType(state, userType) {
      state.tasklistUserType = userType;
    },
    addlabels(state, d){
      state.labels = d || {};
    },
    clearLabels(state) {
      state.labels = {};
      state.labelsClient = null;
    },
    setLabelsInFlightClient(state, clientId) {
      state.labelsInFlightClient = clientId || null;
    },
    setLabelsClient(state, clientId) {
      state.labelsClient = clientId || null;
    },
    navigation(state, d) {
      state.navigation = d;
    },
    headeraction(state, d) {
      state.headeraction = d;
    },
    toogleNavBar(state, d) {
      state.mininavbar = d;
    },
    addLoading(state) {
      state.loading++;
    },
    removeLoading(state) {
      if (state.loading > 0) state.loading--;
    },
    setMenu(state, d) {
      state.menu = d;
    },
    setNewMenu(state, d) {
      state.newmenu = d;
    },
    setCustomMenu(state, d) {
      state.custommenu = d;
    },
    setClientList(state, d) {
      state.clientlist = Array.isArray(d) ? d : [];
      const clientDetails = resolveClientDetails(state.clientlist, state.client);
      if (Object.keys(clientDetails).length > 0) {
        state.clientDetails = clientDetails;
      } else if (!resolveClientId(state.client)) {
        state.clientDetails = {};
      }
    },
    setAiFlag(state, d) {
      state.aiEnabled = d;
    },
    setUserPermission(state, d) {
      state.permissionsEnabled = d;
    },
    setFlowEnabled(state, d) {
      state.isFlowEnabled = !!d;
    },
    setQueueManagementEnabled(state, d) {
      state.isQueueManagementEnabled = !!d;
    },
    setQueueList(state, d) {
      state.queueList = d;
    },
    setComparitive1(state, d) {
      state.isComparitive1enabled = d;
    },
    setComparitive2(state, d) {
      state.isComparitive2enabled = d;
    },
    setGlNavigation(state, d) {
      if (d !== undefined) state.flattened_gl_hierarchy = d;
    },
    setUserPermissionFlag(state, d) {
      state.user_permissions_superadmin = d;
    },
    setChatbotEnabled(state, d) {
      state.chatbotEnabled = d;
    },
    setAccrualsBotEnabled(state, d) {
      state.accrualsbotEnabled = d === true;
    },
    setAccrualsBotFlagReady(state, d) {
      state.accrualsBotFlagReady = d === true;
    },
    setPinCount(state, d) {
      state.pinCount = d;
    },
    setAdmin(state, d) {
      state.isadmin = d;
    },
    sbSuccess(state, payload) {
      const data = typeof payload === 'string'
        ? { text: payload }
        : { ...payload };
      snackBar(state, { ...data, type: 'success', colors: 'success' });
    },
    sbError(state, b) {
      snackBar(state, {type: "error", text: b, colors:"error"});
      // state.sberror = false;
      // state.sberror = true;
      // state.sberrormsg = b;
    },
    sbWarning(state, b) {
      snackBar(state, {type: "warning", text: b, colors:"warning"});
      // state.sbwarning = false;
      // state.sbwarning = true;
      // state.sbwarningmsg = b;
    },
    sbInfo(state, b) {
      snackBar(state, {type: "info", text: b, colors:"info"});
      // state.sbinfo = false;
      // state.sbinfo = true;
      // state.sbinfomsg = b;
    },
    changeNoAuth(state, d) {
      state.noauth = d;
    },
    changeLogin(state, b) {
      state.loginTime = b ? new Date() : null;
      if (!b) state.snackMultValue = [];
      state.login = b;
    },
    setSubscription(state, b) {
      state.subscriptions = b || {};
    },
    setUser(state, d) {
      for (const key in d) {
      state.user[key] = d[key];
      }
    },
    resetUser(state) {
      state.user = {};
    },
    setPermission(state, d) {
      state.permission = d
    },
    setClient(state, d) {
      state.client = d
      const clientDetails = resolveClientDetails(state.clientlist, d);
      state.clientDetails = Object.keys(clientDetails).length > 0
        ? clientDetails
        : (d && typeof d === 'object' ? d : {});
    },
    setClientDetails(state, d) {
      state.clientDetails = d || {};
    },
    setClientCode(state, d) {
      state.clientCode = d
    },
    refreshClient(state, d = true) {
      state.refreshclient = d;
    },
    setHeight(state, d = {}) {
      state.containerheight = d;
    },
    progressSetLoad(state,d){
      state.progressLoading = d
    },
    setdrawerOpen(state,d){
      state.sidedraweropen=d
    },
    setProjectName(state,d){
      state.projectName= d
    },
    setLocationHeader(state,d){
      
      state.LocationHeader=d
    },
    setFilteredLocations(state, locations) {
      state.filteredLocations = locations || [];
    },
    setErpEnabled(state,erpdata){
      state.erpEnabled = erpdata
    },
    // --- Datatable filter persistence (was localStorage) ---
    setTableFilter(state, { key, filter }) {
      if (!key) return;
      Vue.set(state.tableFilters, key, filter || {});
    },
    clearTableFilter(state, key) {
      if (!key) return;
      Vue.delete(state.tableFilters, key);
    },
    // refreshDownloads(state, d){
    //   if(d.axios){
    //     // console.log(d.highlight);
    //     state.downloadLoading = true;
    //     d.axios.post('/conserve/analysis/gettopdownloadlist').then(dt => {
    //       if(dt.data.status == "success"){
    //         if(dt.data.data.length > 0){
    //           state.downloaderror = "";
    //           state.download = dt.data.data;
    //           // console.log(state.download);
    //           if(d.highlight != "no"){
    //             state.downloadHighlight = true;
    //             setTimeout(function(){state.downloadHighlight = false;},3000);
    //           }
    //         }else{
    //           state.download = [];
    //           state.downloaderror = "No downloads";
    //         }
    //       }else {
    //         state.download = [];
    //         state.downloaderror = "Unable to fetch list";
    //       }
    //     }).catch(err => {
    //       console.log(err);
    //       state.download = [];
    //       state.downloaderror = "Error while fetching list";
    //     }).finally(() => {
    //       state.downloadLoading = false;
    //       console.log(state.download);
    //       // this.$store.commit("endDownload", vid);
    //     });
    //   }
    // }
    // startDownload(state, x){
    //   if(state.download.indexOf(x.toString()) === -1) state.download.push(x.toString());
    //   // console.log(this.download);
    // },
    // endDownload(state, x){
    //   let index = state.download.indexOf(x.toString());
    //   if(index > -1) state.download.splice(index, 1);
    //   // console.log(this.download);
    // }
  },
  getters: {
    getClientCode: (state) => state.clientCode,
    axiosObject: () => {
        return Vue.axios;
    },
    novaObject: () => {
      return Vue.prototype.$nova
    },
    // Getter for filtered locations
    filteredLocations: (state) => {
      return state.filteredLocations || [];
    },
    isAiEnabled: (state) => state.aiEnabled,
    isUserPermissionsEnabled: (state) => state.permissionsEnabled,
    isGlNavigationEnabled: (state) => state.flattened_gl_hierarchy,
    isQueueList: (state) => state.queueList,
    isFlowEnabled: (state) => state.isFlowEnabled,
    isQueueEnabled: (state) => state.isQueueManagementEnabled
  },
  actions: {
    async fetchLabels({ commit, state, rootState }) {
      const capturedClient = String(resolveBoundClientId(rootState || state) || '');
      if (!capturedClient) {
        console.warn('[RootStore]: Skipping fetchLabels; missing client');
        return;
      }
      if (state.labelsInFlightClient && String(state.labelsInFlightClient) === capturedClient) {
        return;
      }

      commit('setLabelsInFlightClient', capturedClient);
      if (String(state.labelsClient || '') !== capturedClient) {
        commit('clearLabels');
      }
      try {
        localStorage.setItem(constants.STORAGE_KEYS.LABELS_LIST, '');
        localStorage.setItem(constants.STORAGE_KEYS.LAST_LOGIN_TIME, '');
      } catch (_) { /* storage unavailable */ }

      try {
        const response = await Vue.axios.post(constants.API_URLS.COMMENTARY_GET_PAGES, {
          client: capturedClient,
        });
        const currentClient = String(resolveBoundClientId(rootState || state) || '');
        if (capturedClient !== currentClient) {
          console.log('[RootStore]:', { ignoredStaleLabelsClient: capturedClient, currentClient });
          return;
        }
        if (response?.data?.status === 'success') {
          const labelsList = response.data.data;
          try {
            localStorage.setItem(constants.STORAGE_KEYS.LABELS_LIST, JSON.stringify(labelsList));
            localStorage.setItem(constants.STORAGE_KEYS.LAST_LOGIN_TIME, Date.now().toString());
          } catch (_) { /* storage unavailable */ }
          commit('addlabels', transformLabels(labelsList));
          commit('setLabelsClient', capturedClient);
        } else {
          const message = response?.data?.message || 'Failed to fetch labels';
          console.error('[RootStore]: fetchLabels error', message);
          commit('sbError', message);
        }
      } catch (error) {
        console.error('[RootStore]: fetchLabels error', error);
        const currentClient = String(resolveBoundClientId(rootState || state) || '');
        if (capturedClient === currentClient) {
          commit('sbError', error?.response?.data?.message || error?.message || 'Failed to fetch labels');
        }
      } finally {
        if (String(state.labelsInFlightClient) === capturedClient) {
          commit('setLabelsInFlightClient', null);
        }
      }
    },

    async fetchLocation({ commit }) {
      commit('setAccrualsBotEnabled', false);
      commit('setAccrualsBotFlagReady', false);
      try {
        const dt = await Vue.axios.post(`${getApiUrl()}/v2/client/getlocation`);
        const locData = dt?.data?.data?.[0];
        if (locData) {
          commit('setLocationHeader', locData.location);
          commit('setAiFlag', locData.aiEnabled);
          commit('setUserPermissionFlag', locData.user_permissions_superadmin);
          commit('setErpEnabled', {locationErpEnabled: locData.locationErpEnabled,tbErpEnabled: locData.tbErpEnabled});
          commit('setChatbotEnabled', locData.chatbotEnabled);
          commit('setAccrualsBotEnabled', locData.accrualsbotEnabled === true);
          commit('setPinCount', locData.pinCount ?? -1);
          commit('setUserPermission', locData.permissionsEnabled);
          commit('setFlowEnabled', locData.isFlowEnabled);
          commit('setQueueManagementEnabled', locData.isQueueManagementEnabled);
          commit('setClientCode', locData.code);
          commit('setGlNavigation', locData.flattened_gl_hierarchy);
          commit('setComparitive1', locData.isComparitive1Enabled || false);
          commit('setComparitive2', locData.isComparitive2Enabled || false);
          commit('setQueueList', locData.queue_list || []);
        } else {
          commit('setAccrualsBotEnabled', false);
          commit('sbError', 'Location data not found');
        }
      } catch (err) {
        commit('setAccrualsBotEnabled', false);
        commit('sbError', err.message || 'Failed to fetch location header');
      } finally {
        commit('setAccrualsBotFlagReady', true);
      }
    },

    /**
     * Persist the customizable Location page/column label (client.location → LocationHeader).
     */
    async updateLocationHeader({ commit, rootState, state }, label) {
      const trimmed = String(label || '').trim() || 'Location';
      const clientId = rootState?.client || state.client;
      try {
        if (!clientId) {
          throw new Error('Client id required');
        }
        const res = await Vue.axios.post(
          `${getApiUrl()}/v2/client/edit/${clientId}`,
          {
            location: trimmed,
            data: [{ location: trimmed }],
          }
        );
        if (res?.data?.status !== 'success') {
          throw new Error(res?.data?.message || 'Failed to update location label');
        }
        commit('setLocationHeader', trimmed);
        commit('sbSuccess', 'Location label updated');
        return trimmed;
      } catch (err) {
        commit('sbError', err?.response?.data?.message || err?.message || 'Failed to update location label');
        throw err;
      }
    },
    async fetchFinancialCloseLocations({ commit }) {
      try {
        const response = await Vue.axios.post('/v2/financialclose/location/get');
        if (response.data.status === 'success') {
          return response.data.data || [];
        } else {
          commit('sbError', response.data.message || 'Failed to fetch locations');
          return [];
        }
      } catch (err) {
        commit('sbError', err.message || 'Failed to fetch financial close locations');
        throw err;
      }
    },
    async saveCustomLayout({ commit, state }, { axios, page, cycleId, layout, filter }) {
      try {
        const scopedKey = cycleId || state.client;
        const payload = {
          custom_layout: layout,
          filter: { [scopedKey]: filter || {} },
          page
        };
        const url = '/v2/financialclose/analysis/addcustomlayout';
        const resp = await axios.post(url, { data: payload });
        if (resp.data.status === 'success') {
          // Merge into cached layout so other cycle/client filter keys are preserved
          commit('tasks/MERGE_CUSTOM_LAYOUT_PAGE', {
            page,
            custom_layout: layout,
            scopedKey,
            filter: filter || {},
          }, { root: true });
          commit('sbSuccess', 'Layout saved successfully');
          return resp.data;
        } else throw new Error(resp.data.message || 'Unknown error');
      } catch (err) {
        commit('sbError', err.message || err || 'Unknown error!');
        throw err;
      }
    },
    async clearCustomLayout({ commit }, { axios, page, cycleId }) {
      try {
        const payload = { page, key: cycleId };
        const url = '/v2/financialclose/analysis/removecustomlayout';
        const resp = await axios.post(url, { data: payload });
        if (resp.data.status === 'success') {
          // Clear only this page's cached layout to prevent stale filter data
          commit('tasks/CLEAR_CUSTOM_LAYOUT_PAGE', page, { root: true });
          commit('sbSuccess', 'Filter cleared');
          return resp.data;
        } else throw new Error(resp.data.message || 'Unknown error');
      } catch (err) {
        // Handle "key not found" error gracefully - filter may already be cleared
        const errorMessage = err?.response?.data?.message || err.message || '';
        if (errorMessage.toLowerCase().includes('not found')) {
          // Key not found means filter was already cleared - this is OK
          commit('tasks/CLEAR_CUSTOM_LAYOUT_PAGE', page, { root: true });
          commit('sbSuccess', 'Filter cleared');
          return { status: 'success', message: 'Filter already cleared' };
        }
        commit('sbError', errorMessage || 'Unknown error!');
        throw err;
      }
    }
  },
  modules: {
    admin: require('../modules/admin/store').default,
    varianceanalysis: require('../modules/varianceanalysis/store').default,
    // financialclose: require('../modules/financialclose/store').default
    chatbot: require('../modules/chatbot/store').default,
    bot: require('../modules/bot/store').default,
    shortcuts: require('./modules/shortcuts').default,
    auth: require('./modules/auth').default,
  }
})

function snackBar(state={}, data){
  state.snackMultValue = (state.snackMultValue || []).filter((snack) => snack.showing !== false);

  const now = Date.now();
  const DEDUP_WINDOW_MS = 400;
  // Block rapid duplicate commits (e.g. double-fire), but allow identical messages
  // from separate user actions while an earlier toast is still visible.
  const isDuplicate = state.snackMultValue.some(
    (snack) =>
      snack.text === data.text &&
      snack.type === data.type &&
      snack.addedAt != null &&
      now - snack.addedAt < DEDUP_WINDOW_MS
  );
  if (isDuplicate) return;

  let value = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    addedAt: now,
    showing: true,
    text: data.text,
    type: data.type,
    time: data.time ?? (
      data.actionLabel
        ? constants.SNACKBAR.ACTION_DURATION_MS
        : constants.SNACKBAR.DEFAULT_DURATION_MS
    ),
    colors: data.colors,
    actionLabel: data.actionLabel || '',
    actionPayload: data.actionPayload || null,
  };
  state.snackMultValue.push(value);
}
